import { useTranslation } from 'react-i18next';

import { ErrorMessage, Loading, withValidPermission } from '@Components';
import { useFetchData } from '@CustomHooks';
import { Permission } from '@Models';
import { bopsApi } from '@Network';
import CredentialsSummary from './credentialsSummary';

const CredentialsSummaryContainer = () => {
  const { t } = useTranslation();

  const { data, isLoading, error } = useFetchData(bopsApi.getCredentialsSummary);

  if (isLoading) return <Loading title={t('CredentialsSummary.Loading')} />;

  if (error || !data) {
    return <ErrorMessage internalMessage={`Unable to get credentials summary: ${error}`} />;
  }

  return <CredentialsSummary items={data} />;
};

export default withValidPermission(CredentialsSummaryContainer, [Permission.ManageSuppliers, Permission.ViewSuppliers]);
